import { z } from 'zod';
export const ChannelSchema = z.union([
    z.literal('web'),
    z.literal('mobile'),
    z.literal('desktop')
]);
//# sourceMappingURL=channel.js.map